// 悦听资源
const zsxxwRoutes = Array.from({ length: 7 }, (_, i) => ({
  path: `yuetingResources/index${i + 1}`,
  name: `yuetingResources/Index${i + 1}`,
  component: () => import(`@/views/study/yuetingResources/index${i + 1}.vue`)
}))

export default {
  path: '/study',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [

    // 悦听资源，开始
    ...zsxxwRoutes
    // 悦听资源，结束

  ]
}
